import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './_images/error.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-0e1228ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pay-error" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "错误",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "您有未支付订单，是否取消并继续支付当前订单？", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_el_button, {
      class: "btn-pay",
      onClick: _ctx.payCurrent
    }, {
      default: _withCtx(() => [
        _createTextVNode("支付当前新订单")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_el_button, {
      class: "btn-view",
      onClick: _ctx.toHistory
    }, {
      default: _withCtx(() => [
        _createTextVNode("查看未支付订单")
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}